import axios from 'axios'

let ip = null
if (process.env.REACT_APP_ENV === 'qa') {
  ip = 'https://apiqa.motiners.com/'
} else if (process.env.REACT_APP_ENV === 'dev') {
  ip = 'http://localhost:3001/'
} else {
  ip = 'https://api.motiners.com/'
}

const api = {
  getServerData: (path, callBack) => {
    return new Promise((resolve, reject) => {
      fetch(`${ip}${path}`, {
        credentials: 'include',
        method: 'GET',
        mode: 'cors',
      })
        .then(function (response) {
          return response.json()
        })
        .then(function (myJson) {
          if (!callBack) {
            resolve(myJson)
            return
          }
          resolve(callBack(myJson))
        })
        .catch(function (e) {
          if (process.env.NODE_ENV === 'development') {
            reject(e)
          }
        })
    })
  },

  insertFilePostFetchController: (path, body, callBack) => {
    return new Promise((resolve, reject) => {
      fetch(`${ip}${path}`, {
        credentials: 'include',
        method: 'post',
        body: body,
        mode: 'cors',
      })
        .then(function (response) {
          return response.json()
        })
        .then(function (data) {
          resolve(callBack(data))
        })
    })
  },

  updatefilePostFetchController: (path, body, callBack) => {
    fetch(`${ip}${path}`, {
      credentials: 'include',
      method: 'post',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        callBack(data)
      })
  },

  updateFilePutFetchController: (path, body, callBack) => {
    fetch(`${ip}${path}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'put',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        callBack(data)
      })
  },

  updateFileDeleteFetchController: (path, body, callBack) => {
    fetch(`${ip}${path}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'delete',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        callBack(data)
      })
  },

  generalPostFetchController: (path, body, callBack) => {
    fetch(`${ip}${path}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'post',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        callBack(data)
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          console.error(error)
        }
      })
  },

  generalPutFetchController: (path, body, callBack) => {
    fetch(`${ip}${path}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'put',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        callBack(data)
      })
  },
  asyncPostFetchController: (path, body) => {
    return fetch(`${ip}${path}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        return data
      })
  },
  asyncPutFetchController: async (path, body) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.put(`${ip}${path}`, body, {
          withCredentials: true,
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        })
        resolve(response.data)
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error(err)
        }
      }
    })
  },
  asyncDeleteFetchController: (path, body) => {
    return fetch(`${ip}${path}`, {
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
      body: body,
      mode: 'cors',
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        return data
      })
  },
  apiLoginPostFetchController: (path, body, callBack) => {
    fetch(`${path}`, {
      // credentials:'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'post',
      body: body,
      //mode: 'cors'
    })
      .then(function (response) {
        return response.json()
      })
      .then(function (data) {
        callBack(data)
      })
  },
}

export default api
